/**
 * Auth utilities — delegates to @/lib/auth modules.
 *
 * This file re-exports for backwards compatibility.
 * New code should import directly from @/lib/auth.
 */

// Constants
export { AUTH_TOKEN_CHANGED_EVENT } from '@/lib/auth/constants';
// Magic token
export { clearMagicToken, getMagicToken, setMagicToken } from '@/lib/auth/magicToken';
// Storage helpers
export {
  getAndClearRedirectUrl,
  getStoredUserInfo,
  getValidAuthToken,
  loginWithRedirect,
  requireAuth,
} from './authCompat';

/**
 * Get auth token with caching: Auth0 > magic link > null
 * @deprecated Use resolveToken or resolveAccessToken from @/lib/auth
 */
export const getApiToken = async (fetchToken = null) => {
  if (fetchToken && typeof fetchToken === 'function') {
    try {
      const token = await fetchToken();
      if (token) return token;
    } catch {
      // fall through
    }
  }

  const { getMagicToken: getMT } = await import('@/lib/auth/magicToken');
  const magicToken = getMT();
  if (magicToken) return magicToken.token;

  return null;
};

export const useApiToken = getApiToken;
